import { ButtonBase, Grid } from '@mui/material';
import { Fragment, memo, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import REPAIR_TYPE from 'shared/repairTypeList';
import { formatMultiplies } from 'utils/formatOddDecimal';

const ShaxmatkaRow = ({
  homesData,
  blockIndex,
  padezdIndex,
  floorNumber,
  maxPlace,
  toggleSelectionItem = () => {},
}) => {
  const homeList = useMemo(() => {
    const floorH = homesData?.filter((home) => home?.stage == floorNumber);
    const homes = new Array(maxPlace).fill(null);
    floorH.forEach((h, index) => {
      const place = h?.place ? h?.place - 1 : index;
      homes[place] = h;
    });
    return homes?.map((i, idx) =>
      i
        ? i
        : {
            id: `placeholder-${blockIndex}-${padezdIndex}-${floorNumber}-${idx}`, // STABIL ID
            isFree: true,
          },
    );
  }, [blockIndex, floorNumber, homesData, maxPlace, padezdIndex]);
  return (
    <Fragment>
      <Grid
        container
        rowSpacing={1}
        columns={{
          xs: parseInt(maxPlace),
          sm: parseInt(maxPlace),
        }}
        key={`container-${floorNumber}`}
        className='sheet-home-row'
      >
        {padezdIndex == 0 && (
          <Grid item={true} sm={1} xs={1}>
            <ButtonBase
              className='sheet-home-row-floor h-full w-8 !-ml-3 !mr-1 text-sm font-medium !cursor-default'
              disableRipple
            >
              {floorNumber}
            </ButtonBase>
          </Grid>
        )}
        {homeList.length > 0
          ? homeList.map((item) =>
              item?.contract?.id ? (
                <Grid
                  item={true}
                  sm={1}
                  xs={1}
                  key={`block-${blockIndex}-${padezdIndex}-home-${item.id}`}
                  className={`sheet-home-cell floor-${floorNumber}`}
                  id={`block-${blockIndex}-${padezdIndex}-home-${item.id}`}
                >
                  <ButtonBase
                    className={`block-${blockIndex}-${padezdIndex}-home relative home-item status-${
                      item?.contract?.status == 2 ? 'completed' : item?.status
                    }${item.disabled ? ' is-disabled' : ''} whitespace-nowrap`}
                    id={`home-${item.id}`}
                    onClick={() =>
                      toggleSelectionItem(item.id, padezdIndex, blockIndex)
                    }
                  >
                    {item?.contract?.is_notarial == 1 ? (
                      <div className='absolute -top-1 -right-1 w-3 h-3 rounded bg-[#FFD700] shadow-md' />
                    ) : (
                      ''
                    )}
                    {!(item.stage && parseInt(item.stage) < 0) ? (
                      <Fragment>
                        <div className='home-item-data'>
                          <span className='whitespace-nowrap mr-1'>
                            №: {item.number}
                          </span>
                          {item?.contract?.sum &&
                            item?.contract.hasOwnProperty('discount') &&
                            item?.contract?.square && (
                              <NumericFormat
                                value={
                                  (parseFloat(item.contract.sum) -
                                    parseFloat(item.contract.discount)) /
                                  parseFloat(item.contract.square)
                                }
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-right'
                                suffix={item?.isvalute == '1' ? ' $' : ''}
                              />
                            )}
                        </div>
                        <div className='home-item-data'>
                          {item?.contract?.sum &&
                            item?.contract.hasOwnProperty('discount') && (
                              <NumericFormat
                                value={
                                  item.contract.sum - item.contract.discount
                                }
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-center'
                                suffix={item?.isvalute == '1' ? ' $' : ' UZS'}
                              />
                            )}
                        </div>
                        <div className='home-item-data'>
                          <span>{item.rooms}x</span>
                          <span>
                            <NumericFormat
                              value={item?.square}
                              allowNegative={false}
                              displayType={'text'}
                              decimalScale={2}
                              className='w-full text-right'
                            />
                            &nbsp;
                            <Trans i18nKey='common.global.meter'>
                              m<sup>2</sup>
                            </Trans>
                          </span>
                        </div>
                      </Fragment>
                    ) : (
                      <div className='h-[68px] flex items-center justify-center text-xl'>
                        P
                      </div>
                    )}
                  </ButtonBase>
                </Grid>
              ) : (
                <Grid
                  item={true}
                  sm={1}
                  xs={1}
                  key={`block-${blockIndex}-${padezdIndex}-home-${item.id}`}
                  id={`block-${blockIndex}-${padezdIndex}-home-${item.id}`}
                  className={`sheet-home-cell floor-${floorNumber}`}
                >
                  {' '}
                  {item?.isFree ? (
                    <ButtonBase
                      className={`block-${blockIndex}-${padezdIndex}-home home-item status-null `}
                    />
                  ) : (
                    <ButtonBase
                      className={`block-${blockIndex}-${padezdIndex}-home relative home-item status-${
                        item.status
                      }${item.disabled ? ' is-disabled' : ''} whitespace-nowrap`}
                      id={`home-${item.id}`}
                      onClick={() =>
                        toggleSelectionItem(item.id, padezdIndex, blockIndex)
                      }
                    >
                      {item?.contract?.is_notarial == 1 ? (
                        <div className='absolute -top-1 -right-1 w-3 h-3 rounded bg-[#FFD700] shadow-md' />
                      ) : (
                        ''
                      )}
                      {!(item.stage && parseInt(item.stage) < -2) ? (
                        <Fragment>
                          <div className='home-item-data'>
                            <span className='whitespace-nowrap'>
                              №: {item.number}
                            </span>
                            {item.isrepaired == REPAIR_TYPE.REPAIRED.code ? (
                              <NumericFormat
                                value={item.repaired || ''}
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-right'
                                suffix={item?.isvalute == '1' ? ' $' : ''}
                              />
                            ) : (
                              <NumericFormat
                                value={item.norepaired || ''}
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-right'
                                suffix={item?.isvalute == '1' ? ' $' : ''}
                              />
                            )}
                          </div>
                          <div className='home-item-data'>
                            {item.isrepaired == REPAIR_TYPE.REPAIRED.code ? (
                              <NumericFormat
                                value={
                                  item.repaired && item.square
                                    ? formatMultiplies(
                                        [item.repaired, item.square],
                                        2,
                                      )
                                    : 0
                                }
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-center'
                                suffix={item?.isvalute == '1' ? ' $' : ' UZS'}
                              />
                            ) : (
                              <NumericFormat
                                value={
                                  item.norepaired && item.square
                                    ? formatMultiplies(
                                        [item.norepaired, item.square],
                                        2,
                                      )
                                    : 0
                                }
                                allowNegative={false}
                                displayType={'text'}
                                thousandSeparator={' '}
                                decimalScale={1}
                                className='w-full text-center'
                                suffix={item?.isvalute == '1' ? ' $' : ' UZS'}
                              />
                            )}
                          </div>
                          <div className='home-item-data'>
                            <span>{item.rooms}x</span>
                            <span>
                              <NumericFormat
                                value={item?.square}
                                allowNegative={false}
                                displayType={'text'}
                                decimalScale={2}
                                className='w-full text-right'
                              />
                              &nbsp;
                              <Trans i18nKey='common.global.meter'>
                                m<sup>2</sup>
                              </Trans>
                            </span>
                          </div>
                        </Fragment>
                      ) : (
                        <div className='h-[68px] flex items-center justify-center text-xl'>
                          P
                        </div>
                      )}
                    </ButtonBase>
                  )}
                </Grid>
              ),
            )
          : [1].map((item) => (
              <Grid
                item={true}
                sm={1}
                xs={1}
                key={`home-empty-${item}`}
                className={`sheet-home-cell sheet-home-empty-cell floor-${floorNumber}`}
              >
                <ButtonBase className='home-item is-empty'>
                  <div className='home-item-data'></div>
                </ButtonBase>
              </Grid>
            ))}
      </Grid>
    </Fragment>
  );
};

export default memo(ShaxmatkaRow);
